import { render, staticRenderFns } from "./ServiceView.vue?vue&type=template&id=df4e62c6&"
import script from "./ServiceView.vue?vue&type=script&lang=ts&"
export * from "./ServiceView.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports